import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
 

@Injectable({ providedIn: 'root' })
export class UserService {
    constructor(private http: HttpClient) { }
    getAll() {
        const headerDict = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Access-Control-Allow-Headers': 'Content-Type',
          }

          const requestOptions = {                                                                                                                                                                                 
            headers: new HttpHeaders(headerDict), 
          };
          console.log(this.http.get<any[]>(environment.apiUrl+'/users' ,requestOptions))
        return this.http.get<any[]>(environment.apiUrl+'/users' ,requestOptions);
    }

    getById() {
        const headerDict = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Access-Control-Allow-Headers': 'Content-Type',
          }

          const requestOptions = {                                                                                                                                                                                 
            headers: new HttpHeaders(headerDict), 
          };
        return this.http.get<any>(`${environment.apiUrl}/profile` ,requestOptions);
    }
}